import { IncidentId } from '@collector/sportsapi-client-legacy'
import { useEvent, useEventPeriod } from '@desktop/views/Relation/composables'

import { getLiveDuration } from '../../configuration'
import { injectEventDurationConfig } from '../../provide-inject'

type Duration = {
  period: number
  overtime: number
}

export function useDuration(): {
  getDurationSeconds(duration: Duration): number
  getIncidentDuration(incidentId: IncidentId): Duration | null
  getEventStatusDuration(): Duration | null
} {
  // inject
  const eventDurationConfig = injectEventDurationConfig()

  // composables
  const { event } = useEvent()
  const { numberOfPeriods, periodLengthMinutes, extraPeriodLengthMinutes } =
    useEventPeriod()

  // methods
  function getDurationSeconds(duration: Duration): number {
    return (
      duration.period * periodLengthMinutes.value * 60 +
      duration.overtime * extraPeriodLengthMinutes.value * 60
    )
  }

  function getIncidentDuration(incidentId: IncidentId): Duration | null {
    if (!eventDurationConfig) {
      return null
    }

    return eventDurationConfig.getIncidentDuration(
      incidentId,
      event.value.status_id,
      numberOfPeriods.value,
    )
  }

  function getEventStatusDuration(): Duration | null {
    if (!eventDurationConfig) {
      return null
    }

    const eventStatusDuration = eventDurationConfig.getEventStatusDuration(
      event.value.status_id,
      numberOfPeriods.value,
    )

    return eventStatusDuration ? getLiveDuration(eventStatusDuration) : null
  }

  return {
    getDurationSeconds,
    getIncidentDuration,
    getEventStatusDuration,
  }
}
